<template>
<div>
  <el-card body-style="padding: 0">
    <el-form ref="queryForm" :model="queryForm" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="系统订单编号" prop="orderId">
            <el-input v-model="queryForm.orderId" placeholder="请输入系统订单号"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="平台订单号" prop="plateformOrderNumbers">
            <el-input v-model="queryForm.plateformOrderNumbers" placeholder="平台订单号"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="任务编号" prop="taskId">
            <el-input v-model="queryForm.taskId" placeholder="请输入任务编号"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商家用户名" prop="businessStoreName">
            <el-input v-model="queryForm.businessStoreName" placeholder="请输入商家名"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="店铺名称" prop="shopName">
            <el-input v-model="queryForm.shopName" placeholder="请输入店铺名"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="试客用户名" prop="customerName">
            <el-input v-model="queryForm.customerName" placeholder="请输入试客名"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="试客平台账号" prop="customerPlateformUserName">
            <el-input v-model="queryForm.customerPlateformUserName" placeholder="请输入试客平台账号"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="任务类型" prop="tasktypeId">
            <el-select v-model="queryForm.tasktypeId" clearable placeholder="请选择任务类型">
              <el-option
                  v-for="item in allTaskTypes"
                  :key="item.id"
                  :label="item.taskName"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="接单时间" prop="orderTime">
            <el-date-picker
                v-model="queryForm.orderTime"
                type="datetime"
                value-format="yyyy-MM-dd"
                placeholder="选择接单时间"
                >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="时间段" prop="timeRange">
            <el-date-picker
                v-model="queryForm.timeRange"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8" :offset="4">
          <el-form-item>
            <el-button type="primary" size="small"
                       @click="submitQueryForm()" icon="el-icon-search">
              查询</el-button>
            <el-button type="primary" size="small" plain
                       @click="resetQueryForm()" icon="el-icon-refresh">
              重置</el-button>
            <el-button type="primary" size="small" plain
                       @click="exportOrderInfos()" icon="el-icon-refresh">
              导出</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
  <el-card body-style="padding: 1%">
    <el-tabs class="el-tabs-self" v-model="tabsActive" @tab-click="tableChange">
      <el-tab-pane v-for="(item, index) in tabsActives" :key="index" :label="item.lable" :name="item.value"></el-tab-pane>
    </el-tabs>
    <table-datac ref="orderTabcom" :order_status="orderStatus" @queryData="getData"></table-datac>
  </el-card>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import tableDatac from "../../components/TableData";
import {getAllTaskType} from "../../api/b2cbusiness/b2c_tasktype";
export default {
  name: "OrderManagelist",
  mixins:[MixinCUD],
  components:{ tableDatac },
  data(){
    return {
      tableData:[],
      allTaskTypes: [],
      queryFormRefName:"queryForm",
      queryForm:{
        orderId: '',
        plateformOrderNumbers: '',
        taskId: null,
        businessStoreName: '',
        shopName: '',
        customerName: '',
        customerPlateformUserName: '',
        tasktypeId: null,
        orderTime: '',
        timeRange: []
      },
      options:[],
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
      tabsActive: "first",
      tabsActives: {
        "first": {
          lable:"所有订单",
          value:"first"
        },
        "202109020001": {
          lable: "待放出",
          value: "202109020001"
        },
        "202109010001": {
          lable: "待接订单",
          value: "202109010001"
        },
        "202109010002": {
          lable: "待审核订单",
          value: "202109010002"
        },
        "202109020002": {
          lable: "待操作订单",
          value:"202109020002"
        },
        "202205090001": {
          lable: "金额异常订单",
          value: "202205090001"
        },
        "202112300001": {
          lable: "驳回中订单",
          value: "202112300001"
        },
        "202110040002": {
          lable: "确认发货订单",
          value: "202110040002"
        },
        "202109030002": {
          lable: "待评价订单",
          value: "202109030002"
        },
        "202111030003": {
          lable: "催评价订单",
          value: "202111030003"
        },
        "202109030003": {
          lable: "待确认订单",
          value: "202109030003"
        },
        "202109030004": {
          lable: "已完成订单",
          value: "202109030004"
        },
        "202204200001": {
          lable: "追评",
          value: "202204200001"
        },
        "202309260001": {
          lable: "追评确认",
          value: "202309260001"
        },
        "202109030005": {
          lable: "已取消订单",
          value: "202109030005"
        },
      },

    }
  },
  computed: {
    orderStatus(){
      return this.tabsActives[this.tabsActive];
    }
  },
  mounted() {
    getAllTaskType().then(res=>{
      if (res.success){
        this.allTaskTypes = res.data;
      }
    });
    if (this.$route.query.tabsActive){
      this.tabsActive = this.$route.query.tabsActive;
    }
    this.tableChange(this.tabsActives[this.tabsActive], null);
  },
  activated() {
    this.getData();
  },
  methods: {
    tableChange(tab, evnt){
      console.log(this.tabsActives[this.tabsActive])
      this.$refs.orderTabcom.changeOrderTabs(this.tabsActives[this.tabsActive]);
    },
    getData(){
      this.queryForm.status = this.tabsActives[this.tabsActive].value;
      this.$refs.orderTabcom.getData(this.queryForm);
    },
    exportOrderInfos(){
      this.queryForm.status = this.tabsActives[this.tabsActive].value;
      this.$refs.orderTabcom.exportOrderInfos(this.queryForm);
    }
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}

.el-tabs-self{
  position: relative;
  width: 100%;
}
</style>
